import React from 'react';

export default function ReadyToBeShippedIcon() {
  return (
    <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5923_312)">
        <path
          d="M19.5 39C30.2696 39 39 30.2696 39 19.5C39 8.73045 30.2696 0 19.5 0C8.73045 0 0 8.73045 0 19.5C0 30.2696 8.73045 39 19.5 39Z"
          fill="currentColor"
        />
        <path
          d="M25 16.4L16 11.21"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.5 22.9999V14.9999C29.4996 14.6492 29.4071 14.3047 29.2315 14.0011C29.056 13.6974 28.8037 13.4453 28.5 13.2699L21.5 9.26989C21.196 9.09436 20.8511 9.00195 20.5 9.00195C20.1489 9.00195 19.804 9.09436 19.5 9.26989L12.5 13.2699C12.1963 13.4453 11.944 13.6974 11.7685 14.0011C11.5929 14.3047 11.5004 14.6492 11.5 14.9999V22.9999C11.5004 23.3507 11.5929 23.6951 11.7685 23.9988C11.944 24.3024 12.1963 24.5546 12.5 24.7299L19.5 28.7299C19.804 28.9055 20.1489 28.9979 20.5 28.9979C20.8511 28.9979 21.196 28.9055 21.5 28.7299L28.5 24.7299C28.8037 24.5546 29.056 24.3024 29.2315 23.9988C29.4071 23.6951 29.4996 23.3507 29.5 22.9999Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7695 13.96L20.4995 19.01L29.2295 13.96"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5 29.08V19"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5923_312">
          <rect width="39" height="39" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
